'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SmartCustomTextImage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _SmartImageCustomText = require('./SmartImage.customText.styled');

var S = _interopRequireWildcard(_SmartImageCustomText);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SmartCustomTextImage = exports.SmartCustomTextImage = function (_React$PureComponent) {
    _inherits(SmartCustomTextImage, _React$PureComponent);

    function SmartCustomTextImage() {
        _classCallCheck(this, SmartCustomTextImage);

        return _possibleConstructorReturn(this, (SmartCustomTextImage.__proto__ || Object.getPrototypeOf(SmartCustomTextImage)).apply(this, arguments));
    }

    _createClass(SmartCustomTextImage, [{
        key: 'render',
        value: function render() {
            var _props$definition = this.props.definition,
                topText = _props$definition.topText,
                bottomText = _props$definition.bottomText;

            return React.createElement(S.Content, null, React.createElement(S.TopText, null, topText), bottomText && React.createElement(S.BottomText, null, bottomText));
        }
    }]);

    return SmartCustomTextImage;
}(React.PureComponent);
//# sourceMappingURL=SmartImage.customText.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/SmartImage/formats/SmartImage.customText.js